export default __webpack_public_path__ + "static/media/close.8355ae66.svg";